/* eslint-disable @next/next/no-img-element */
'use client'

import UnifiedPlayMark from '@/components/embedding/UnifiedPlayMark'
import { createThumbnailHoverHandlers } from '@/components/video/HoverAnimatedThumbnail'
import { FC } from 'react'

/**
 * カルーセルに並べる1本分の最小情報。
 * 埋め込み（ScenarioNodeWithVideoUrl）と動画個別ページ（ScenarioVideoWithUrl）で
 * 型が違うため、呼び出し側でこの形に詰め替えて渡す。
 */
export interface CarouselVideoItem {
  id: string
  thumbnailUrl?: string | null
  animatedThumbnailUrl?: string | null
  title?: string | null
}

export interface CarouselCardProps {
  item: CarouselVideoItem
  onSelect: () => void
}

const CarouselCard: FC<CarouselCardProps> = ({ item, onSelect }) => {
  return (
    <div className="carousel-card group" onClick={onSelect}>
      <div className="carousel-thumbnail">
        {item.thumbnailUrl ? (
          <img
            src={item.thumbnailUrl}
            alt={item.title ?? ''}
            {...createThumbnailHoverHandlers(item.thumbnailUrl, item.animatedThumbnailUrl)}
          />
        ) : (
          <div className="carousel-thumbnail-placeholder">
            <UnifiedPlayMark />
          </div>
        )}
      </div>
    </div>
  )
}

export default CarouselCard
